<div class="file-preview-dialog">
  <div class="dialog-header">
    <h2>{{ data.fileName }}</h2>
  </div>

  <div class="dialog-content">
    <div class="file-container">
      <!-- Image preview -->
      @if (isImage) {
        <img [src]="safeUrl" [alt]="data.fileName" />
      }

      <!-- PDF preview -->
      @if (isPdf) {
        <iframe [src]="safeUrl" [title]="data.fileName" class="pdf-viewer"></iframe>
      }
    </div>
  </div>

  <div class="dialog-footer">
    <button class="download-btn" (click)="download()">
      <mat-icon>download</mat-icon>
      Download
    </button>
    <button (click)="close()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  </div>
</div>
